import React from 'react';
import { Tooltip, Typography } from 'antd';
import cn from 'classnames';
import InfoCard from '../../common/InfoCard/InfoCard';
import { CardChangeButton } from '../../../../../components/Card';
import DottedBorderBackground from '../../common/DottedBorderBackground/DottedBorderBackground';
import { convertPenniesToRub } from '../../../../../helpers/convertPenniesToRub';
import styles from './PersonalAccountCard.module.scss';
import TypeIcon from '../HouseRegistrationTypeManager/components/TypeIcon/TypeIcon';
import moment from 'moment';

const { Text } = Typography;

const PersonalAccountCard = ({
  account,
  onDeleteAccount,
  registrationTypeHouse,
  rootClassName,
}) => {
  const handleChangeButtonClick = () => {
    onDeleteAccount(account);
  };

  return (
    <InfoCard
      title={
        account?.hasAccessType ? (
          <div className={styles.typeBox}>
            <TypeIcon type={registrationTypeHouse || { id: 0, name: '' }} />
            Л/С {account.type.name}
          </div>
        ) : (
          `Л/С ${account.type.name}`
        )
      }
      action={
        typeof onDeleteAccount === 'function' && (
          <CardChangeButton
            text="Удалить"
            onClick={handleChangeButtonClick}
          />
        )
      }
      className={cn(styles.root, rootClassName)}
    >
      <div className={styles.container}>
        <div className={styles.content}>
          <Text className={styles.number}>{account.account}</Text>
          <DottedBorderBackground className={styles.debtContainer}>
            <Text className={styles.debtTitle}>Задолженность</Text>
            <Text className={styles.debtSum}>
              {account.amount < 0
                ? `${convertPenniesToRub(-1 * account.amount)} руб`
                : 'Отсутствует'}
            </Text>
          </DottedBorderBackground>
        </div>
        <div className={styles.dateBox}>
          {!!account?.openDate && (
            <Tooltip title="Дата открытия ЛС">
              <span className={styles.date}>
                {moment(account?.openDate).format('DD.MM.YYYY')}
              </span>
            </Tooltip>
          )}
          {!!account?.closeDate && (
            <Tooltip title="Дата закрытия ЛС">
              <span className={styles.date}>
                {moment(account?.closeDate).format('DD.MM.YYYY')}
              </span>
            </Tooltip>
          )}
        </div>
      </div>
    </InfoCard>
  );
};

export default PersonalAccountCard;
